import React from "react";
import { useTranslation } from "react-i18next";
import { FaShieldAlt } from "react-icons/fa";
import { FaChalkboardTeacher, FaUserGraduate } from "react-icons/fa";
import { FaUserTie, FaCode } from "react-icons/fa6";
import { GrUserWorker } from "react-icons/gr";
import { IoDocumentOutline } from "react-icons/io5";
import { GrTest } from "react-icons/gr";

import { ReactComponent as Icon } from "../../icons/work-experience/case.svg";
import "./workexperience.css";

const ICONS = {
  trainee: <FaUserGraduate />,
  teacher: <FaChalkboardTeacher />,
  manager: <FaUserTie />,
  developer: <FaCode />,
  maintainer: <GrUserWorker />,
  document: <IoDocumentOutline />,
  tester: <GrTest />,
};

export default function Responsabilities({ id }) {
  const { t } = useTranslation();
  const responsibilities = t(`experience.${id}.responsibilities`, {
    returnObjects: true,
  });

  return (
    <div className="content-container">
      <h2 className="we-card-title">{t("experience.responsibilities")}</h2>
      <div className="bullet-list">
        {responsibilities.map(({ text, icon }) => (
          <span key={text} className="responsability">
            {ICONS[icon] || <FaShieldAlt />}
            <p>{text}</p>
          </span>
        ))}
      </div>
      <div className="we-bg-icon">
        <Icon id="case" />
      </div>
    </div>
  );
}
